import { render, staticRenderFns } from "./bigBag.vue?vue&type=template&id=dc6f10b4&scoped=true"
import script from "./bigBag.vue?vue&type=script&lang=js"
export * from "./bigBag.vue?vue&type=script&lang=js"
import style0 from "./bigBag.vue?vue&type=style&index=0&id=dc6f10b4&prod&lang=scss"
import style1 from "./bigBag.vue?vue&type=style&index=1&id=dc6f10b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6f10b4",
  null
  
)

export default component.exports